import { UploadWorkflowContact } from 'services/api/postUploadWorkflowContacts';

export const parseCSV = (lines: string[]) => {
    const headers = lines[0].split(',').map((header) => header.trim()) as (keyof UploadWorkflowContact)[];

    const requiredHeaders = ['firstName', 'lastName', 'phoneNumber'] as (keyof UploadWorkflowContact)[];
    const optionalHeaders = ['crmStatus', 'crmId'] as (keyof UploadWorkflowContact)[];
    const missingHeaders = requiredHeaders.filter((header) => !headers.includes(header));

    const contacts: UploadWorkflowContact[] = [];
    let invalidPhoneCount = 0;
    const invalidPhonesData: { phoneNumber: string; name: string }[] = [];

    for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;

        const values = lines[i].split(',').map((value) => value.trim());
        const contact: UploadWorkflowContact = {
            firstName: '',
            lastName: '',
            phoneNumber: '',
        };

        headers.forEach((header, index) => {
            if (requiredHeaders.includes(header) || optionalHeaders.includes(header)) {
                contact[header] = values[index] || '';
            }
        });

        if (
            contact.phoneNumber &&
            (!contact.phoneNumber.startsWith('+1') || contact.phoneNumber.replace(/\D/g, '').length !== 11)
        ) {
            invalidPhonesData.push({
                phoneNumber: contact.phoneNumber,
                name: `${contact.firstName} ${contact.lastName}`,
            });
            invalidPhoneCount++;
        } else {
            contacts.push(contact);
        }
    }

    return { contacts, invalidPhoneCount, invalidPhonesData, missingHeaders };
};
